(() => {
  'use strict';

  if (window.__smoofProductMasterV01) return;
  window.__smoofProductMasterV01 = true;

  const VERSION = '0.8.130';
  const EDITOR_ASSET_BUILD = '20261009-450';
  const ROOT = document.documentElement;
  const HANDLE = location.pathname.match(/\/products\/([^/?#]+)/)?.[1] || '';
  const MASTER_SCRIPT_URL = document.currentScript?.src || '';

  const CORE_FIELDS = Object.freeze({
      designMode: '3474d16c-f4b6-4517-8f74-f88c27e5c914',
      fontSection: '3d46135c-72f6-437f-ac78-e194b5d52b9b',
      fontFamily: '052c068b-772b-4d04-af0d-56214e55cce3',
      customFontFamily: 'c4505509-8d93-4f44-96c9-48a271501375',
      backgroundColor: 'dcde59d1-5fef-4e99-8d22-30e2ec19197e',
      text1: '2375ec9f-695e-489a-ae63-4dc66fbcbb3f',
      text1Style: '8cbb313f-ef10-40a4-a711-b894c8c15c2f',
      text1Color: '1b10591e-29cb-455c-a22f-5d534a275702',
      text2: '5f47cc89-1d8f-4089-9919-514d4d1d3640',
      text2Style: '999ff02f-9bc5-4ddf-996d-98459628780d',
      text2Color: 'f9b38c60-cd0d-4740-94a4-5b235d7ab60c',
      text3: 'aa1edcda-2cc3-4d6f-affd-d2db797ab684',
      text3Style: 'c3b03f1a-c9a4-495e-b138-51bde4cfcbe8',
      text3Color: 'dace7c47-c686-47bc-8580-4444848e6190',
      numberEnabled: '3d6f15f5-b6a7-44d8-8e66-d80fe15b7603',
      numberText: '45b6444d-2b8c-431d-9594-91a6ab688d18',
      numberStyle: 'f0b04c23-daf0-420c-9572-6d05e339241e',
      numberColor: '5e5d6fe5-7f13-4891-9903-9ad8949dbb95',
      arrowColor: '331a45ae-bd3d-4b85-8c7f-a8cbf014b032',
      arrowLabelColor: '1f69ffa6-f179-46de-8ee6-5a90ac70558f',
      brandDotColor: '3f615f11-8440-41a9-af77-fe79452d77f1',
      logoUpload: 'ab71cded-7e41-485b-a39d-c01bffd08b3a',
      logoUpload2: '8fcfc7b6-6f0a-4407-be42-91d1a80509ce',
      linkMode: 'a72f9e68-08ec-4c9d-a038-8cd2096681a2',
      nfcIconColor: '7c8d415d-fe33-43d6-8b0a-7574bac91bee',
      nfcCircleColor: '401dec5d-4f5e-4e9d-b7fa-c942c1143a77'
  });

  /*
   * Physische Produkteigenschaften sind Profile und keine Easify-Felder.
   * Die Optionspositionen sind nur innerhalb des jeweiligen Profils gueltig.
   */
  const EASIFY_CORE_V2_OPTION_SET_ID = 621890;
  const EASIFY_LEGACY_OPTION_SET_ID = 550568;
  const WOOD_VALUES = Object.freeze(['oak', 'earth', 'obsidian']);
  const DOT_ME_EDITOR_POLICY = Object.freeze({
    backgroundLocked: true,
    forceMonochromeLaser: true,
    laserEdgeMarginMm: 1.5
  });

  const DESIGN_SURFACES = Object.freeze({
    epoxyGlossy: Object.freeze({
      material: 'epoxy-resin',
      finish: 'glossy',
      effect: 'epoxy-dome',
      qrBackground: 'white',
      productionModes: Object.freeze(['color-print']),
      bleedMm: 2.5,
      vectorRequiredModes: Object.freeze([])
    }),
    pvcMatte: Object.freeze({
      material: 'pvc',
      finish: 'matte',
      effect: 'none',
      qrBackground: 'white',
      productionModes: Object.freeze(['color-print']),
      bleedMm: 2.5,
      vectorRequiredModes: Object.freeze([])
    }),
    stainlessBrushed: Object.freeze({
      material: 'stainless-steel',
      finish: 'brushed',
      effect: 'none',
      qrBackground: 'transparent',
      productionModes: Object.freeze(['laser', 'color-print']),
      bleedMm: 2.5,
      vectorRequiredModes: Object.freeze(['laser'])
    })
  });

  const PHYSICAL_BASES = Object.freeze({
    wood: Object.freeze({
      material: 'wood',
      selectableMaterials: WOOD_VALUES
    }),
    stainlessSteel: Object.freeze({
      material: 'stainless-steel',
      selectableMaterials: Object.freeze(['stainless-steel'])
    })
  });

  /*
   * Reine Lineal-Metadaten. Diese Werte veraendern weder Produktdarstellung,
   * Druckflaeche, Skalierung noch Exportgeometrie.
   */
  const RULER_MEASUREMENTS = Object.freeze({
    rhl: Object.freeze({
      title: 'BASE Ø 94 mm',
      details: Object.freeze(['Höhe 9,4 mm', 'Rand 7 mm']),
      valuesMm: Object.freeze({ printDiameter: 80, outerDiameter: 94, height: 9.4, rim: 7 })
    }),
    qhl: Object.freeze({
      title: 'BASE 94 × 94 mm',
      details: Object.freeze(['Höhe 9,4 mm', 'Eckenradius 12 mm', 'Rand 7 mm', 'Branding Ø 7 mm']),
      valuesMm: Object.freeze({ printDiameter: 80, width: 94, height: 94, depth: 9.4, cornerRadius: 12, rim: 7, brandingDiameter: 7 })
    }),
    qhs: Object.freeze({
      title: 'BASE 94 × 94 mm',
      details: Object.freeze(['Tiefe 12–31 mm', 'Eckenradius 12 mm', 'Rand 7 mm', 'Branding Ø 7 mm']),
      valuesMm: Object.freeze({ printDiameter: 80, width: 94, height: 94, topDepth: 12, bottomDepth: 31, cornerRadius: 12, rim: 7, brandingDiameter: 7 })
    }),
    rhs: Object.freeze({
      title: 'BASE 94 × 92,5 mm',
      details: Object.freeze(['Tiefe 28 mm', 'Fuß ca. 25 mm', 'Rand 7 mm']),
      valuesMm: Object.freeze({ printDiameter: 80, width: 94, height: 92.5, depth: 28, footWidth: 25, rim: 7 })
    }),
    rml: Object.freeze({
      title: 'BASE Ø 90 mm',
      details: Object.freeze(['Höhe 5,7 mm', 'Rand 5 mm']),
      valuesMm: Object.freeze({ printDiameter: 80, outerDiameter: 90, height: 5.7, rim: 5 })
    })
  });

  const VARIANT_AXES = Object.freeze({
    woodBase: Object.freeze([
      Object.freeze({ key: 'nfc', label: 'NFC-Funktion', values: Object.freeze(['Ohne NFC', 'Mit NFC']) }),
      Object.freeze({ key: 'format', label: 'Größe der Druckfläche', values: Object.freeze(['ø 80 mm']) }),
      Object.freeze({ key: 'material', label: 'Holzart', values: Object.freeze(['Oak (hell)', 'Earth (braun)', 'Obsidian (schwarz)']) })
    ]),
    epoxyDot: Object.freeze([
      Object.freeze({ key: 'nfc', label: 'NFC-Funktion', values: Object.freeze(['Ohne NFC', 'Mit NFC']) }),
      Object.freeze({ key: 'format', label: 'Größe der Druckfläche', values: Object.freeze(['ø 80 mm']) })
    ]),
    pvcDot: Object.freeze([
      Object.freeze({ key: 'nfc', label: 'NFC-Funktion', values: Object.freeze(['Ohne NFC', 'Mit NFC']) }),
      Object.freeze({ key: 'format', label: 'Größe der Druckfläche', values: Object.freeze(['ø 80 mm', 'ø 110 mm']) })
    ]),
    stainlessDot: Object.freeze([
      Object.freeze({ key: 'format', label: 'Druckformat', values: Object.freeze(['ø 80 mm', 'ø 110 mm']) }),
      Object.freeze({ key: 'process', label: 'Ausführung', values: Object.freeze(['Lasergravur Schwarz-Weiß', 'Farbdruck']) })
    ]),
    fixed80: Object.freeze([
      Object.freeze({ key: 'format', label: 'Größe der Druckfläche', values: Object.freeze(['ø 80 mm']) })
    ])
  });

  const PRODUCT_PROFILES = Object.freeze({
    'test-base-rhl-dot-gl': {
      id: 'base-rhl-wood-single',
      optionSetId: EASIFY_CORE_V2_OPTION_SET_ID,
      shape: 'round',
      orientation: 'horizontal',
      material: { kind: 'wood', values: WOOD_VALUES },
      physicalBase: PHYSICAL_BASES.wood,
      rulerMeasurements: RULER_MEASUREMENTS.rhl,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.woodBase,
      surfaces: ['front'],
      sharedQrPayload: true,
      sharedNfcPayload: true,
      supportsNfc: true,
      standardDesignPolicy: 'nfc-only',
      optionAxes: { nfc: 1, format: 2, material: 3 },
      defaults: { diameterMm: 80, materialCode: 'oak', printProcess: 'epoxy' },
      scene: {
        presentation: {
          enabled: true,
          adapter: 'homography-product',
          singleSurfaceToolbar: true,
          preserveNativeFront: false,
          assets: {
            oak: {
              front: 'smoof-rhl-oak-front-v3.png',
              threeQuarter: 'smoof-rhl-oak-3q-v2.png'
            },
            earth: {
              front: 'smoof-rhl-earth-front-v3.png',
              threeQuarter: 'smoof-rhl-earth-3q-v2.png'
            },
            obsidian: {
              front: 'smoof-rhl-obsidian-front-v3.png',
              threeQuarter: 'smoof-rhl-obsidian-3q-v2.png'
            }
          },
          assetVersion: '20260827-149-7mm-front-v3',
          views: ['front', 'threeQuarter'],
          apertureGeometry: {
            front: { left: 17.0, top: 17.0, width: 66.0, height: 66.0, rotationDeg: 0 },
            threeQuarter: {
              left: 19.0,
              top: 35.5,
              width: 62.0,
              height: 21.0,
              rotationDeg: 0,
              artworkRotationDeg: 0
            }
          },
          editorBaseGeometry: { left: -2.1, top: -2.1, width: 104.2, height: 104.2 },
          artworkSurfaceRatio: 0.7068,
          artworkOverscan: 1,
          // Map the canonical 70.68% trim circle into the accepted
          // 68.772% visible aperture of the RHL Front asset.
          frontArtworkScale: 0.973005,
          threeQuarterArtworkOverscan: 1.01,
          threeQuarterViewScale: 1,
          baseShadowMode: 'asset',
          projection: {
            engine: 'homography-v1',
            sourceGeometry: 'print-circle',
            calibrationId: 'rhl-print-circle-3q-v1',
            threeQuarterCorners: [
              [22.5691, 35.2364],
              [77.4309, 35.7716],
              [88.4032, 58.0731],
              [10.5263, 58.6084]
            ],
            calibrationSeedCorners: [
              [22.5691, 35.2364],
              [77.4309, 35.7716],
              [88.4032, 58.0731],
              [10.5263, 58.6084]
            ]
          },
          geometrySource: 'matched-alpha-aperture-rhl-oak-earth-obsidian-2000-7mm-v2',
          calibrationStatus: 'user-calibrated-accepted-20260827'
        }
      },
      variantBridge: 'legacy',
      rollout: 'test-legacy'
    },
    'test-base-qhl-dot-gl': {
      id: 'base-qhl-wood-single',
      optionSetId: EASIFY_CORE_V2_OPTION_SET_ID,
      shape: 'square',
      orientation: 'horizontal',
      material: { kind: 'wood', values: WOOD_VALUES },
      physicalBase: PHYSICAL_BASES.wood,
      rulerMeasurements: RULER_MEASUREMENTS.qhl,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.woodBase,
      surfaces: ['front'],
      sharedQrPayload: true,
      sharedNfcPayload: true,
      supportsNfc: true,
      standardDesignPolicy: 'nfc-only',
      optionAxes: { nfc: 1, format: 2, material: 3 },
      defaults: {
        diameterMm: 80,
        materialCode: 'oak',
        printProcess: 'epoxy',
        backgroundColor: '#c0c0c0'
      },
      scene: {
        presentation: {
          enabled: true,
          adapter: 'homography-product',
          singleSurfaceToolbar: true,
          preserveNativeFront: false,
          assets: {
            oak: {
              front: 'smoof-qhl-oak-front-v1.png',
              threeQuarter: 'smoof-qhl-oak-3q-v1.png'
            },
            earth: {
              front: 'smoof-qhl-earth-front-v1.png',
              threeQuarter: 'smoof-qhl-earth-3q-v1.png'
            },
            obsidian: {
              front: 'smoof-qhl-obsidian-front-v1.png',
              threeQuarter: 'smoof-qhl-obsidian-3q-v1.png'
            }
          },
          assetVersion: '20260827-156-qhl-v1',
          views: ['front', 'threeQuarter'],
          apertureGeometry: {
            front: { left: 16.6, top: 16.5, width: 66.7, height: 66.7, rotationDeg: 0 },
            threeQuarter: {
              left: 24.25,
              top: 37.75,
              width: 50.75,
              height: 17.6,
              rotationDeg: 0,
              artworkRotationDeg: 0
            }
          },
          editorBaseGeometry: { left: -2.1, top: -2.1, width: 104.2, height: 104.2 },
          artworkSurfaceRatio: 0.7068,
          artworkOverscan: 1,
          // Map the canonical 70.68% trim circle into the accepted
          // 69.5014% visible aperture of the QHL Front asset.
          frontArtworkScale: 0.983325,
          threeQuarterArtworkOverscan: 1.01,
          threeQuarterViewScale: 1,
          baseShadowMode: 'asset',
          projection: {
            engine: 'homography-v1',
            sourceGeometry: 'print-circle',
            calibrationId: 'qhl-print-circle-3q-v1',
            threeQuarterCorners: [
              [16.4139, 43.9786],
              [51.5611, 35.4148],
              [87.6896, 45.8519],
              [42.9973, 61.1954]
            ],
            calibrationSeedCorners: [
              [16.4139, 43.9786],
              [51.5611, 35.4148],
              [87.6896, 45.8519],
              [42.9973, 61.1954]
            ]
          },
          geometrySource: 'measured-alpha-aperture-qhl-oak-earth-obsidian-2000-v1',
          calibrationStatus: 'user-calibrated-accepted-20260827'
        }
      },
      variantBridge: 'legacy',
      rollout: 'test-legacy'
    },
    'test-base-qhs-dot-gl': {
      id: 'base-qhs-wood-double',
      optionSetId: EASIFY_CORE_V2_OPTION_SET_ID,
      shape: 'square',
      orientation: 'standing',
      material: { kind: 'wood', values: WOOD_VALUES },
      physicalBase: PHYSICAL_BASES.wood,
      rulerMeasurements: RULER_MEASUREMENTS.qhs,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.woodBase,
      scene: {
        base: {
          kind: 'wood-stand-placeholder',
          shape: 'rounded-square',
          widthPercent: 82,
          cornerRadiusPercent: 9
        },
        presentation: {
          enabled: true,
          assetPrefix: 'qhs_shadow_v2',
          assetVersion: '20260826-111',
          views: ['front', 'threeQuarter'],
          apertureGeometry: {
            front: { left: 25.8025, top: 25.7025, width: 48.345, height: 48.345, rotationDeg: 0 },
            threeQuarter: {
              left: 38.8391,
              top: 25.9043,
              width: 32.2576,
              height: 46.4326,
              rotationDeg: -5.8132,
              artworkRotationDeg: 0.9
            }
          },
          editorBaseGeometry: { left: -23.02, top: -23.02, width: 146.04, height: 146.04 },
          artworkSurfaceRatio: 0.7068,
          artworkOverscan: 1,
          frontArtworkScale: 1.01,
          threeQuarterArtworkOverscan: 1.035,
          threeQuarterViewScale: 1.3,
          baseShadowMode: 'asset',
          projection: {
            engine: 'homography-v1',
            sourceGeometry: 'print-circle',
            calibrationId: 'qhs-print-circle-3q-v2',
            threeQuarterCorners: [
              [33.4207, 17.8711],
              [75.9554, 18.9779],
              [79.6984, 77.4488],
              [37.1276, 80.8765]
            ],
            calibrationSeedCorners: [
              [33.4207, 17.8711],
              [75.9554, 18.9779],
              [79.6984, 77.4488],
              [37.1276, 80.8765]
            ]
          },
          geometrySource: 'measured-alpha-ellipse-and-base-edge-qhs-oak-2000'
        }
      },
      surfaces: ['front', 'back'],
      sharedQrPayload: true,
      sharedNfcPayload: true,
      supportsNfc: true,
      standardDesignPolicy: 'nfc-only',
      optionAxes: { nfc: 1, format: 2, material: 3 },
      defaults: {
        diameterMm: 80,
        materialCode: 'oak',
        printProcess: 'epoxy',
        backgroundColor: '#c0c0c0'
      },
      variantBridge: 'profile-v2',
      rollout: 'test-active'
    },
    'test-base-rhs-dot-gl': {
      id: 'base-rhs-wood-double',
      optionSetId: EASIFY_CORE_V2_OPTION_SET_ID,
      shape: 'round',
      orientation: 'standing',
      material: { kind: 'wood', values: WOOD_VALUES },
      physicalBase: PHYSICAL_BASES.wood,
      rulerMeasurements: RULER_MEASUREMENTS.rhs,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.woodBase,
      scene: {
        base: {
          kind: 'wood-stand-rhs',
          shape: 'round',
          widthPercent: 89,
          cornerRadiusPercent: 50
        },
        presentation: {
          enabled: true,
          assetPrefix: 'rhs',
          views: ['front', 'threeQuarter'],
          apertureGeometry: {
            front: { left: 18.35, top: 18.25, width: 63.3, height: 63.3, rotationDeg: 0 },
            threeQuarter: {
              left: 32.9846,
              top: 18.3991,
              width: 47.0879,
              height: 74.8148,
              rotationDeg: 5.6013,
              artworkRotationDeg: 5.6013
            }
          },
          editorBaseGeometry: { left: 0, top: 0, width: 100, height: 100 },
          artworkSurfaceRatio: 0.7068,
          artworkOverscan: 1,
          frontArtworkScale: 0.9,
          threeQuarterArtworkOverscan: 1.02,
          threeQuarterViewScale: 1,
          baseShadowMode: 'asset',
          projection: {
            engine: 'homography-v1',
            sourceGeometry: 'print-circle',
            calibrationId: 'rhs-print-circle-3q-v1',
            edgeBleedPx: 2,
            threeQuarterCorners: [
              [34.2117, 18.5204],
              [81.6441, 17.4656],
              [79.8651, 80.2746],
              [32.9496, 82.0198]
            ],
            calibrationSeedCorners: [
              [34.2117, 18.5204],
              [81.6441, 17.4656],
              [79.8651, 80.2746],
              [32.9496, 82.0198]
            ]
          },
          geometrySource: 'measured-alpha-aperture-rhs-oak-2000',
          calibrationStatus: 'browser-calibrated-20260825'
        }
      },
      surfaces: ['front', 'back'],
      sharedQrPayload: true,
      sharedNfcPayload: true,
      supportsNfc: true,
      standardDesignPolicy: 'nfc-only',
      optionAxes: { nfc: 1, format: 2, material: 3 },
      defaults: {
        diameterMm: 80,
        materialCode: 'oak',
        printProcess: 'epoxy',
        backgroundColor: '#c0c0c0'
      },
      variantBridge: 'profile-v2',
      rollout: 'test-active'
    },
    'test-dot-gl': {
      id: 'dot-gl-epoxy-single',
      optionSetId: EASIFY_CORE_V2_OPTION_SET_ID,
      shape: 'round',
      orientation: 'flat',
      material: { kind: 'epoxy-resin', values: ['epoxy-resin'] },
      physicalBase: null,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.epoxyDot,
      surfaces: ['front'],
      sharedQrPayload: true,
      sharedNfcPayload: true,
      supportsNfc: true,
      standardDesignPolicy: 'nfc-only',
      optionAxes: { nfc: 1, format: 2 },
      defaults: {
        diameterMm: 80,
        materialCode: 'epoxy-resin',
        printProcess: 'color-print',
        backgroundColor: '#ffffff'
      },
      variantBridge: 'profile-v2',
      rollout: 'test-active'
    },
    'test-dot-ma': {
      id: 'dot-ma-pvc-single',
      optionSetId: EASIFY_CORE_V2_OPTION_SET_ID,
      shape: 'round',
      orientation: 'flat',
      material: { kind: 'pvc', values: ['pvc'] },
      physicalBase: null,
      designSurface: DESIGN_SURFACES.pvcMatte,
      shopifyVariantAxes: VARIANT_AXES.pvcDot,
      surfaces: ['front'],
      sharedQrPayload: true,
      sharedNfcPayload: true,
      supportsNfc: true,
      standardDesignPolicy: 'nfc-only',
      optionAxes: { nfc: 1, format: 2 },
      defaults: {
        diameterMm: 80,
        materialCode: 'pvc',
        printProcess: 'color-print',
        backgroundColor: '#ffffff'
      },
      variantBridge: 'profile-v2',
      rollout: 'test-active'
    },
    'test-dot-me': {
      id: 'dot-me-stainless-single',
      optionSetId: EASIFY_CORE_V2_OPTION_SET_ID,
      shape: 'round',
      orientation: 'flat',
      material: { kind: 'stainless-steel', values: ['stainless-steel'] },
      physicalBase: null,
      designSurface: DESIGN_SURFACES.stainlessBrushed,
      shopifyVariantAxes: VARIANT_AXES.stainlessDot,
      surfaceEffect: 'none',
      surfaces: ['front'],
      sharedQrPayload: true,
      sharedNfcPayload: false,
      supportsNfc: false,
      standardDesignPolicy: 'diameter-80-laser-only',
      optionAxes: { format: 1, process: 2 },
      processValues: ['laser', 'color-print'],
      editorPolicy: DOT_ME_EDITOR_POLICY,
      defaults: { diameterMm: 80, materialCode: 'stainless-steel', printProcess: 'laser' },
      variantBridge: 'profile-v2',
      rollout: 'test-active'
    },
    'test-base-rml-dot-gl': {
      id: 'base-rml-stainless-epoxy-single',
      optionSetId: EASIFY_CORE_V2_OPTION_SET_ID,
      shape: 'round',
      orientation: 'horizontal',
      material: { kind: 'stainless-base', values: ['stainless-steel'] },
      physicalBase: PHYSICAL_BASES.stainlessSteel,
      rulerMeasurements: RULER_MEASUREMENTS.rml,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.fixed80,
      surfaces: ['front'],
      supportsNfc: false,
      sharedQrPayload: true,
      sharedNfcPayload: false,
      standardDesignPolicy: 'nfc-only',
      optionAxes: { format: 1 },
      defaults: {
        diameterMm: 80,
        materialCode: 'stainless-steel',
        printProcess: 'color-print',
        backgroundColor: '#ffffff'
      },
      scene: {
        base: {
          kind: 'rml-photo',
          shape: 'round',
          widthPercent: 103.8,
          asset: 'smoof-rml-front-v1.png'
        },
        presentation: {
          enabled: true,
          adapter: 'homography-product',
          singleSurfaceToolbar: true,
          assets: {
            default: {
              front: 'smoof-rml-front-v1.png',
              threeQuarter: 'smoof-rml-3q-v1.png'
            }
          },
          assetVersion: '20260827-140',
          views: ['front', 'threeQuarter'],
          apertureGeometry: {
            front: { left: 14.66, top: 14.66, width: 70.68, height: 70.68, rotationDeg: 0 },
            threeQuarter: {
              left: 18.2,
              top: 38.25,
              width: 64.35,
              height: 20.25,
              rotationDeg: -0.9,
              artworkRotationDeg: -0.9
            }
          },
          editorBaseGeometry: { left: -1.9, top: -1.9, width: 103.8, height: 103.8 },
          artworkSurfaceRatio: 0.7068,
          artworkOverscan: 1,
          frontArtworkScale: 1,
          threeQuarterArtworkOverscan: 1.01,
          threeQuarterViewScale: 1,
          baseShadowMode: 'asset',
          projection: {
            engine: 'homography-v1',
            sourceGeometry: 'print-circle',
            calibrationId: 'rml-print-circle-3q-v1',
            threeQuarterCorners: [
              [21.5461, 35.1597],
              [79.3094, 35.7816],
              [90.9585, 59.1494],
              [8.4327, 59.648]
            ],
            calibrationSeedCorners: [
              [21.5461, 35.1597],
              [79.3094, 35.7816],
              [90.9585, 59.1494],
              [8.4327, 59.648]
            ]
          },
          geometrySource: 'measured-alpha-aperture-rml-3q-2000',
          calibrationStatus: 'user-browser-calibrated-v3-20260827'
        }
      },
      variantBridge: 'profile-v2',
      rollout: 'test-active'
    },
    'base-rhl-dot-gl': {
      id: 'base-rhl-wood-single-live', optionSetId: EASIFY_LEGACY_OPTION_SET_ID,
      shape: 'round', orientation: 'horizontal',
      material: { kind: 'wood', values: WOOD_VALUES },
      physicalBase: PHYSICAL_BASES.wood,
      rulerMeasurements: RULER_MEASUREMENTS.rhl,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.woodBase,
      surfaces: ['front'], supportsNfc: true,
      optionAxes: { nfc: 1, format: 2, material: 3 },
      defaults: { diameterMm: 80, materialCode: 'oak', printProcess: 'epoxy' },
      variantBridge: 'legacy', rollout: 'staged'
    },
    'base-qhl-dot-gl': {
      id: 'base-qhl-wood-single-live', optionSetId: EASIFY_LEGACY_OPTION_SET_ID,
      shape: 'square', orientation: 'horizontal',
      material: { kind: 'wood', values: WOOD_VALUES },
      physicalBase: PHYSICAL_BASES.wood,
      rulerMeasurements: RULER_MEASUREMENTS.qhl,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.woodBase,
      surfaces: ['front'], supportsNfc: true,
      optionAxes: { nfc: 1, format: 2, material: 3 },
      defaults: { diameterMm: 80, materialCode: 'oak', printProcess: 'epoxy' },
      variantBridge: 'legacy', rollout: 'staged'
    },
    'base-rhs-dot-gl': {
      id: 'base-rhs-wood-double-live', optionSetId: EASIFY_LEGACY_OPTION_SET_ID,
      shape: 'round', orientation: 'standing',
      material: { kind: 'wood', values: WOOD_VALUES },
      physicalBase: PHYSICAL_BASES.wood,
      rulerMeasurements: RULER_MEASUREMENTS.rhs,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.woodBase,
      surfaces: ['front', 'back'], supportsNfc: true,
      sharedQrPayload: true, sharedNfcPayload: true,
      optionAxes: { nfc: 1, format: 2, material: 3 },
      defaults: { diameterMm: 80, materialCode: 'oak', printProcess: 'epoxy' },
      variantBridge: 'legacy', rollout: 'staged'
    },
    'base-qhs-dot-gl': {
      id: 'base-qhs-wood-double-live', optionSetId: EASIFY_LEGACY_OPTION_SET_ID,
      shape: 'square', orientation: 'standing',
      material: { kind: 'wood', values: WOOD_VALUES },
      physicalBase: PHYSICAL_BASES.wood,
      rulerMeasurements: RULER_MEASUREMENTS.qhs,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.woodBase,
      surfaces: ['front', 'back'], supportsNfc: true,
      sharedQrPayload: true, sharedNfcPayload: true,
      optionAxes: { nfc: 1, format: 2, material: 3 },
      defaults: { diameterMm: 80, materialCode: 'oak', printProcess: 'epoxy' },
      variantBridge: 'legacy', rollout: 'staged'
    },
    'dot-gl': {
      id: 'dot-gl-epoxy-single-live', optionSetId: EASIFY_LEGACY_OPTION_SET_ID,
      shape: 'round', orientation: 'flat',
      material: { kind: 'epoxy-resin', values: ['epoxy-resin'] },
      physicalBase: null,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.epoxyDot,
      surfaces: ['front'], supportsNfc: true,
      sharedQrPayload: true, sharedNfcPayload: true,
      optionAxes: { nfc: 1, format: 2 },
      defaults: { diameterMm: 80, materialCode: 'epoxy-resin', printProcess: 'color-print' },
      variantBridge: 'legacy', rollout: 'staged'
    },
    'dot-ma': {
      id: 'dot-ma-pvc-single-live', optionSetId: EASIFY_LEGACY_OPTION_SET_ID,
      shape: 'round', orientation: 'flat',
      material: { kind: 'pvc', values: ['pvc'] },
      physicalBase: null,
      designSurface: DESIGN_SURFACES.pvcMatte,
      shopifyVariantAxes: VARIANT_AXES.pvcDot,
      surfaces: ['front'], supportsNfc: true,
      sharedQrPayload: true, sharedNfcPayload: true,
      optionAxes: { nfc: 1, format: 2 },
      defaults: { diameterMm: 80, materialCode: 'pvc', printProcess: 'color-print' },
      variantBridge: 'legacy', rollout: 'staged'
    },
    'dot-me': {
      id: 'dot-me-stainless-single-live', optionSetId: EASIFY_LEGACY_OPTION_SET_ID,
      shape: 'round', orientation: 'flat',
      material: { kind: 'stainless-steel', values: ['stainless-steel'] },
      physicalBase: null,
      designSurface: DESIGN_SURFACES.stainlessBrushed,
      shopifyVariantAxes: VARIANT_AXES.stainlessDot,
      surfaceEffect: 'none',
      surfaces: ['front'], supportsNfc: false,
      sharedQrPayload: true, sharedNfcPayload: false,
      optionAxes: { format: 1, process: 2 },
      processValues: ['laser', 'color-print'],
      editorPolicy: DOT_ME_EDITOR_POLICY,
      defaults: { diameterMm: 80, materialCode: 'stainless-steel', printProcess: 'laser' },
      variantBridge: 'legacy', rollout: 'staged'
    },
    'base-rml-dot-gl': {
      id: 'base-rml-stainless-epoxy-single-live', optionSetId: EASIFY_LEGACY_OPTION_SET_ID,
      shape: 'round', orientation: 'horizontal',
      material: { kind: 'stainless-base', values: ['stainless-steel'] },
      physicalBase: PHYSICAL_BASES.stainlessSteel,
      rulerMeasurements: RULER_MEASUREMENTS.rml,
      designSurface: DESIGN_SURFACES.epoxyGlossy,
      shopifyVariantAxes: VARIANT_AXES.fixed80,
      surfaces: ['front'], supportsNfc: false,
      sharedQrPayload: true, sharedNfcPayload: false,
      optionAxes: { format: 1 },
      defaults: { diameterMm: 80, materialCode: 'stainless-steel', printProcess: 'color-print' },
      variantBridge: 'legacy', rollout: 'staged'
    }
  });

  const EDITOR_OWNED_FIELDS = Object.freeze([
      'fontSection',
      'fontFamily',
      'customFontFamily',
      'backgroundColor',
      'text1',
      'text1Style',
      'text1Color',
      'text2',
      'text2Style',
      'text2Color',
      'text3',
      'text3Style',
      'text3Color',
      'numberEnabled',
      'numberText',
      'numberStyle',
      'numberColor',
      'arrowColor',
      'arrowLabelColor',
      'brandDotColor',
      'logoUpload',
      'logoUpload2',
      'nfcIconColor',
      'nfcCircleColor'
  ]);

  const LAUNCH_PROFILE_ALIASES = Object.freeze({
    'base-rhl-dot-gl': 'test-base-rhl-dot-gl',
    'base-qhl-dot-gl': 'test-base-qhl-dot-gl',
    'base-rhs-dot-gl': 'test-base-rhs-dot-gl',
    'base-qhs-dot-gl': 'test-base-qhs-dot-gl',
    'base-rml-dot-gl': 'test-base-rml-dot-gl',
    'dot-gl': 'test-dot-gl',
    'dot-ma': 'test-dot-ma',
    'dot-me': 'test-dot-me'
  });
  const resolveProfileHandle = handle => {
    const normalized = String(handle || '');
    return LAUNCH_PROFILE_ALIASES[normalized] || normalized;
  };

  const PROFILE_SOURCE = PRODUCT_PROFILES[resolveProfileHandle(HANDLE)];
  if (!PROFILE_SOURCE) return;

  const PROFILE = Object.freeze({
    ...PROFILE_SOURCE,
    handle: HANDLE,
    fields: CORE_FIELDS,
    editorOwned: EDITOR_OWNED_FIELDS,
    surfaceCount: PROFILE_SOURCE.surfaces.length
  });

  window.SmoofProductProfiles = Object.freeze({
    version: VERSION,
    easifyCoreOptionSetId: EASIFY_CORE_V2_OPTION_SET_ID,
    current: PROFILE,
    get(handle = HANDLE) {
      const source = PRODUCT_PROFILES[resolveProfileHandle(handle)];
      return source ? Object.freeze({ ...source, handle, fields: CORE_FIELDS }) : null;
    },
    isTestProfile(handle = HANDLE) {
      const profileHandle = resolveProfileHandle(handle);
      return profileHandle.startsWith('test-') && Boolean(PRODUCT_PROFILES[profileHandle]);
    },
    isStaged(handle = HANDLE) {
      return PRODUCT_PROFILES[resolveProfileHandle(handle)]?.rollout === 'staged';
    },
    getShopifyVariantAxes(handle = HANDLE) {
      return PRODUCT_PROFILES[resolveProfileHandle(handle)]?.shopifyVariantAxes || Object.freeze([]);
    },
    handles: Object.freeze(Object.keys(PRODUCT_PROFILES))
  });

  ROOT.dataset.smoofEditorBuild = EDITOR_ASSET_BUILD;
  ROOT.dataset.smoofProductProfile = PROFILE.id;
  ROOT.dataset.smoofSurfaceCount = String(PROFILE.surfaceCount);
  ROOT.dataset.smoofMaterialKind = PROFILE.material.kind;
  ROOT.dataset.smoofPrintSurfaceMaterial = PROFILE.designSurface?.material || PROFILE.material.kind;
  ROOT.dataset.smoofPhysicalBaseMaterial = PROFILE.physicalBase?.material || 'none';
  ROOT.dataset.smoofProfileRollout = PROFILE.rollout || 'legacy';
  ROOT.dataset.smoofProfileCapability = window.SmoofProductProfiles.isTestProfile(HANDLE)
    ? 'accepted-editor'
    : 'legacy';
  ROOT.dataset.smoofSurfaceEffect = PROFILE.designSurface?.effect || PROFILE.surfaceEffect || 'epoxy-dome';
  ROOT.dataset.smoofQrBackground = PROFILE.designSurface?.qrBackground || PROFILE.qrBackground || (
    String(PROFILE.material.kind).includes('stainless-steel')
      ? 'transparent'
      : 'white'
  );
  ROOT.dataset.smoofGuidesDefault = PROFILE.guidesDefaultVisible === true
    ? 'visible'
    : 'hidden';
  ROOT.dataset.smoofBackgroundLocked = PROFILE.editorPolicy?.backgroundLocked === true
    ? 'true'
    : 'false';
  ROOT.dataset.smoofForceMonochromeLaser = PROFILE.editorPolicy?.forceMonochromeLaser === true
    ? 'true'
    : 'false';
  ROOT.dataset.smoofLaserEdgeMarginMm = String(
    Math.max(0, Number(PROFILE.editorPolicy?.laserEdgeMarginMm) || 0)
  );

  function loadEditorAsset(fileName) {
    if (!MASTER_SCRIPT_URL || document.querySelector(`script[data-smoof-master-asset="${fileName}"]`)) return;
    const script = document.createElement('script');
    const assetUrl = new URL(fileName, MASTER_SCRIPT_URL);
    assetUrl.searchParams.set('smoof_build', EDITOR_ASSET_BUILD);
    script.src = assetUrl.href;
    script.async = false;
    script.dataset.smoofMasterAsset = fileName;
    document.head.appendChild(script);
  }

  function loadEditorStyle(fileName) {
    if (!MASTER_SCRIPT_URL || document.querySelector(`link[data-smoof-master-style="${fileName}"]`)) return;
    const link = document.createElement('link');
    const assetUrl = new URL(fileName, MASTER_SCRIPT_URL);
    assetUrl.searchParams.set('smoof_build', EDITOR_ASSET_BUILD);
    link.rel = 'stylesheet';
    link.href = assetUrl.href;
    link.dataset.smoofMasterStyle = fileName;
    document.head.appendChild(link);
  }

  // Shopify can retain historical bodies for reused asset names. During the
  // short dependency bootstrap, let those accepted legacy modules recognise
  // the exact canonical launch handle as their former test-prefixed handle.
  const startsWithDescriptor = Object.getOwnPropertyDescriptor(String.prototype, 'startsWith');
  const needsCanonicalTestBridge = (
    startsWithDescriptor?.value
    && !startsWithDescriptor.value.call(HANDLE, 'test-')
    && window.SmoofProductProfiles.isTestProfile(HANDLE)
  );
  let restoreCanonicalTestBridge = () => {};
  if (needsCanonicalTestBridge) {
    Object.defineProperty(String.prototype, 'startsWith', {
      ...startsWithDescriptor,
      value(search, ...args) {
        if (String(this) === HANDLE && String(search) === 'test-') return true;
        return startsWithDescriptor.value.call(this, search, ...args);
      }
    });
    let restored = false;
    restoreCanonicalTestBridge = () => {
      if (restored) return;
      restored = true;
      Object.defineProperty(String.prototype, 'startsWith', startsWithDescriptor);
    };
    window.addEventListener('load', restoreCanonicalTestBridge, { once: true });
    window.setTimeout(restoreCanonicalTestBridge, 8000);
  }

  loadEditorAsset('smoof-editor-native-i18n-v2.js');
  loadEditorAsset('smoof-brand-artwork-v1.js');
  loadEditorStyle('smoof-ruler-menu-v1.css');
  loadEditorStyle('smoof-number-visibility-context-v2.css');
  loadEditorStyle('smoof-template-cards-v9.css');
  loadEditorStyle('smoof-template-languages-v2.css');
  loadEditorStyle('smoof-editor-tour-v5.css');
  loadEditorStyle('smoof-product-media-presentation-v4.css');
  loadEditorStyle('smoof-design-service-overlay-v1.css');
  loadEditorStyle('smoof-percent-input-v8.css');

  [
    'smoof-design-mode-contract-v4.js',
    'smoof-product-variant-v3.js',
    'smoof-dotme-delivery-time-v2.js',
    'smoof-template-library-v22.js',
    'smoof-template-catalog-v7.js',
    'smoof-pdf-logo-v1.js',
    'smoof-logo-upload-v4.js',
    'smoof-logo-crop-v3.js',
    'smoof-logo-colour-v1.js',
    'smoof-logo-copy-v2-37.js',
    'smoof-logo-background-v2-34.js',
    'smoof-main-logo-alignment-v2-31.js',
    'smoof-product-media-router-v7.js',
    'smoof-product-media-editor-return-v4.js',
    'smoof-product-media-presentation-v3.js',
    'smoof-editor-gallery-lock-v1.js',
    'smoof-product-scene-v16.js',
    'smoof-cart-preview-v6.js',
    'smoof-cart-preview-v7.js',
    'smoof-cart-preview-v8.js',
    'smoof-product-measurements-v2.js',
    'smoof-surface-controller-v14.js',
    'smoof-editor-tour-v9.js',
    'smoof-percent-input-v11.js'
  ].forEach(loadEditorAsset);

  if (PROFILE.editorPolicy) loadEditorAsset('smoof-dotme-policy-v6.js');
  loadEditorAsset('smoof-360-ui-v2.js');
  if (PROFILE.id === 'base-rhl-wood-single') loadEditorAsset('smoof-rhl-360-editor-v8.js');
  if (PROFILE.id === 'base-qhs-wood-double') loadEditorAsset('smoof-qhs-360-editor-v8.js');
  if (PROFILE.id === 'base-rhs-wood-double') loadEditorAsset('smoof-rhs-360-editor-v4.js');
  if (PROFILE.id === 'base-rml-stainless-epoxy-single') loadEditorAsset('smoof-rml-360-editor-v3.js');
  if (PROFILE.id === 'base-qhl-wood-single') loadEditorAsset('smoof-qhl-360-editor-v4.js');
  if (PROFILE.id === 'dot-gl-epoxy-single') loadEditorAsset('smoof-dot-gl-360-editor-v4.js');
  if (PROFILE.id === 'dot-me-stainless-single') loadEditorAsset('smoof-dot-me-360-editor-v7.js');
  if (PROFILE.id === 'dot-ma-pvc-single') loadEditorAsset('smoof-dot-ma-360-editor-v3.js');

  // Die akzeptierten Editorbausteine gelten fuer Test- und kanonische Launchhandles.
  if (window.SmoofProductProfiles.isTestProfile(HANDLE)) {
    loadEditorAsset('smoof-mockup-download-v11.js');
    loadEditorAsset('smoof-rich-text-v5.js');
    loadEditorAsset('smoof-curved-text-v5.js');
    loadEditorStyle('smoof-curved-text-v2.css');
    loadEditorAsset('smoof-custom-font-registry-v16.js');
    loadEditorAsset('smoof-custom-text-v19.js');
    loadEditorAsset('smoof-custom-pictogram-v1-7.js');
    loadEditorAsset('smoof-social-platforms-v11.js');
    loadEditorAsset('smoof-cart-wait-experience-v31.js');
  }

  const semanticName = role => role.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  const escapeValue = value => window.CSS?.escape ? CSS.escape(value) : String(value).replace(/["\\]/g, '\\$&');

  function fieldRoot(role) {
    const id = PROFILE.fields[role];
    if (!id) return null;
    const selector = `[data-option-id="${escapeValue(id)}"]`;
    const exact = document.querySelector(selector);
    return exact?.closest(selector) || exact || null;
  }

  function selectedText(role) {
    const root = fieldRoot(role);
    if (!root) return '';
    const checked = root.querySelector('input:checked');
    const label = checked?.closest('label');
    return String((window.SmoofNativeI18n?.readText(label) || label?.textContent) || checked?.value || root.querySelector('select')?.value || '').trim();
  }

  function selectedEditorDesign() {
    const contract = window.SmoofDesignModeContract;
    const contractMode = contract?.read?.()?.code || '';
    if (contractMode) return contract?.isEditorCode?.(contractMode) === true;

    const variantMode = String(window.SmoofProductVariant?.get?.()?.designMode || '');
    if (/personal/i.test(variantMode)) return true;
    return /personalisiertes\s+design|personalized\s+design|design-konfigurator/i.test(
      selectedText('designMode')
    );
  }

  function selectedPersonalizedDesign() {
    return selectedEditorDesign();
  }

  function readInputValue(role, fallback = '') {
    const root = fieldRoot(role);
    if (!root) return fallback;
    const input = root.querySelector('input:checked, select, input[type="color"], input:not([type="hidden"]), textarea');
    return input?.value || fallback;
  }

  function dispatchFieldChange(role) {
    const root = fieldRoot(role);
    if (!root) return;
    root.dispatchEvent(new CustomEvent('smoof:source-field-change', {
      bubbles: true,
      detail: { role, value: readInputValue(role) }
    }));
  }

  function markFields() {
    Object.keys(PROFILE.fields).forEach(role => {
      const root = fieldRoot(role);
      if (!root) return;
      root.dataset.smoofField = semanticName(role);
      root.dataset.smoofFieldRole = role;
    });
  }

  function editorShellReady() {
    return ROOT.dataset.smoofUiShellReady === 'true' && Boolean(document.querySelector('[data-smoof-ui-commandbar]'));
  }

  function ensureCompactCard() {
    let card = document.querySelector('[data-smoof-product-master-card]');
    if (card) return card;

    const designRoot = fieldRoot('designMode');
    if (!designRoot?.parentNode) return null;

    card = document.createElement('section');
    card.dataset.smoofProductMasterCard = 'true';
    card.hidden = true;
    card.innerHTML = `
      <span data-smoof-product-master-card-icon aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="m4 16-1 5 5-1L19 9l-4-4L4 16Z"></path><path d="m13.5 6.5 4 4"></path></svg>
      </span>
      <span data-smoof-product-master-card-copy>
        <strong>${window.SmoofI18n.copy('Design-Editor aktiv', 'Design editor active')}</strong>
        <small>${window.SmoofI18n.copy('Alle Gestaltungsoptionen finden Sie direkt in der Vorschau.', 'All design settings are available directly in the preview.')}</small>
      </span>
      <button type="button" data-smoof-product-master-open-editor>${window.SmoofI18n.copy('Editor öffnen', 'Open editor')}</button>
    `;

    designRoot.insertAdjacentElement('afterend', card);
    card.querySelector('[data-smoof-product-master-open-editor]')?.addEventListener('click', () => {
      const target = document.querySelector('[data-smoof-ui-commandbar-host], .po-livePreview-root, media-gallery.product__gallery, .product__gallery');
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      document.querySelector('[data-smoof-ui-commandbar] button')?.focus({ preventScroll: true });
    });
    return card;
  }

  function applyCompactMode() {
    markFields();
    const contract = window.SmoofDesignModeContract;
    const designMode = contract?.read?.()?.code || '';
    const service = contract?.isServiceCode?.(designMode) === true;
    const active = selectedEditorDesign() && editorShellReady();
    const sourceHidden = active || service;
    ROOT.dataset.smoofProductMasterActive = active ? 'true' : 'false';
    ROOT.dataset.smoofDesignServiceUi = service ? 'static-product' : 'inactive';

    PROFILE.editorOwned.forEach(role => {
      const root = fieldRoot(role);
      if (!root) return;
      root.dataset.smoofEditorSourceHidden = sourceHidden ? 'true' : 'false';
      root.setAttribute('aria-hidden', sourceHidden ? 'true' : 'false');
    });

    const card = ensureCompactCard();
    if (card) card.hidden = !active;

    const designRoot = fieldRoot('designMode');
    const help = designRoot?.querySelector('.po-field-helpText');
    if (help) {
      if (service) {
        help.dataset.smoofServiceHidden = 'true';
        help.style.setProperty('display', 'none', 'important');
        help.setAttribute('aria-hidden', 'true');
      } else if (help.dataset.smoofServiceHidden === 'true') {
        delete help.dataset.smoofServiceHidden;
        help.style.removeProperty('display');
        help.removeAttribute('aria-hidden');
      }
    }
  }

  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      applyCompactMode();
    });
  }

  window.SmoofProductMaster = Object.freeze({
    version: VERSION,
    profile: PROFILE,
    fieldRoot,
    readInputValue,
    selectedEditorDesign,
    selectedPersonalizedDesign,
    dispatchFieldChange,
    schedule
  });

  document.addEventListener('change', event => {
    const owner = event.target?.closest?.('[data-option-id]');
    if (owner?.dataset?.optionId === PROFILE.fields.nfcIconColor) dispatchFieldChange('nfcIconColor');
    if (owner?.dataset?.optionId === PROFILE.fields.nfcCircleColor) dispatchFieldChange('nfcCircleColor');
    schedule();
  }, true);
  document.addEventListener('input', schedule, true);
  window.addEventListener('smoof:product-variant-change', schedule);

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['checked', 'value', 'data-smoof-ui-shell-ready']
  });

  schedule();
})();

/*
 * Variantenwechsel-Optimierung
 *
 * Der bestehende Varianten-Bridge wartet aus Sicherheitsgruenden darauf,
 * dass Easify den gesamten Preview-Root ersetzt. Easify baut inzwischen
 * haeufig nur dessen Inhalt neu auf. In diesem Fall ist die neue Vorschau
 * bereits korrekt, die Abdeckung bleibt aber bis zum 4-Sekunden-Fallback
 * sichtbar. Dieser additive Waechter beendet die Abdeckung, sobald die
 * sichtbare Produktszene und alle Editor-Layer nachweislich zur gewaehlt
 * Variante passen. Der eigentliche Shopify-/Easify-Wechsel bleibt unberuehrt.
 */
(() => {
  'use strict';

  if (window.__smoofVariantTransitionOptimizerV1) return;
  window.__smoofVariantTransitionOptimizerV1 = true;

  const WOOD_CODES = ['oak', 'earth', 'obsidian'];
  const OPTION_INDEX = { nfc: 1, format: 2, wood: 3 };

  let expectedState = null;
  let transitionStartedAt = 0;
  let checkPending = false;
  let stableReadyFrames = 0;

  function optionInputs(index) {
    return Array.from(
      document.querySelectorAll(
        `main input[type="radio"][data-option-index="${index}"]`
      )
    );
  }

  function targetInput(event) {
    const target = event.target instanceof Element
      ? event.target
      : null;

    if (!target) return null;

    const direct = target.matches('input[type="radio"][data-option-index]')
      ? target
      : null;

    if (direct) return direct;

    const label = target.closest('label[for]');
    return label ? document.getElementById(label.htmlFor) : null;
  }

  function parseDiameter(value, position) {
    const match = String(value || '').match(/(\d+(?:[.,]\d+)?)/);
    const parsed = Number(match?.[1]?.replace(',', '.'));

    if (Number.isFinite(parsed) && parsed > 0) return parsed;
    return position === 1 ? 110 : 80;
  }

  function captureExpectedState(event) {
    if (
      event.type === 'keydown' &&
      event.key !== 'Enter' &&
      event.key !== ' '
    ) {
      return;
    }

    const input = targetInput(event);

    if (
      !input?.matches('input[type="radio"][data-option-index]') ||
      input.checked ||
      input.disabled
    ) {
      return;
    }

    const current = window.SmoofProductVariant?.get?.();
    if (!current) return;

    const optionIndex = Number(input.dataset.optionIndex);
    if (![1, 2, 3].includes(optionIndex)) return;

    const inputs = optionInputs(optionIndex);
    const position = inputs.indexOf(input);

    expectedState = {
      nfcEnabled: Boolean(current.nfcEnabled),
      diameterMm: Number(current.diameterMm) || 80,
      woodCode: String(current.woodCode || '')
    };

    if (optionIndex === OPTION_INDEX.nfc) {
      expectedState.nfcEnabled = position === 1;
    } else if (optionIndex === OPTION_INDEX.format) {
      expectedState.diameterMm = parseDiameter(input.value, position);
    } else if (optionIndex === OPTION_INDEX.wood) {
      expectedState.woodCode = WOOD_CODES[position] || '';
    }

    transitionStartedAt = performance.now();
    stableReadyFrames = 0;
    scheduleCheck();
  }

  function previewMatchesExpectedState() {
    if (!expectedState) return false;

    const root = document.querySelector('.po-livePreview-root');
    const stage = root?.querySelector(
      '.po-livePreview-stage .konvajs-content'
    );
    const scene = root?.querySelector('[data-smoof-product-scene-base]');
    const sceneCode = String(scene?.dataset?.smoofProductSceneBase || '');
    const sceneWood = String(scene?.dataset?.smoofWood || '');
    const nfcFrame = root?.querySelector('[data-smoof-nfc-frame]');

    if (
      !root ||
      !stage ||
      !root.querySelector('[data-smoof-background-base]') ||
      !root.querySelector('[data-smoof-vector-preview]') ||
      root.querySelectorAll('[data-smoof-text-frame]').length < 3
    ) {
      return false;
    }

    /*
     * Der NFC-Editor behaelt seinen Frame beim Abschalten im DOM und blendet
     * ihn nur aus. Deshalb darf der Rueckwechsel nicht darauf warten, dass
     * der Knoten entfernt wird. Fuer den bereits schnellen Hinweg bleibt die
     * bisherige Existenzpruefung bewusst erhalten.
     */
    const nfcFrameVisible = (() => {
      if (!nfcFrame || nfcFrame.hidden) return false;

      const style = window.getComputedStyle(nfcFrame);
      const rect = nfcFrame.getBoundingClientRect();
      const opacity = Number.parseFloat(style.opacity || '1');

      return style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        opacity > 0 &&
        rect.width > 0 &&
        rect.height > 0;
    })();

    const nfcMatches = expectedState.nfcEnabled
      ? Boolean(nfcFrame)
      : !nfcFrameVisible;

    const diameterToken = `-${expectedState.diameterMm}-`;
    const diameterMatches = !sceneCode || sceneCode.includes(diameterToken);
    const woodMatches = !sceneWood || !expectedState.woodCode ||
      sceneWood === expectedState.woodCode;

    return nfcMatches && diameterMatches && woodMatches;
  }

  function endTransitionIfReady() {
    checkPending = false;

    const cover = document.querySelector('[data-smoof-preview-transition]');
    const transitionActive =
      document.documentElement.dataset.smoofVariantTransition === 'true' ||
      cover?.dataset.visible === 'true';

    if (!transitionActive || !expectedState) {
      stableReadyFrames = 0;
      return;
    }

    /* Kein alter Frame darf die Abdeckung direkt nach pointerdown schliessen. */
    if (performance.now() - transitionStartedAt < 180) {
      window.setTimeout(scheduleCheck, 40);
      return;
    }

    if (!previewMatchesExpectedState()) {
      stableReadyFrames = 0;
      window.setTimeout(scheduleCheck, 50);
      return;
    }

    stableReadyFrames += 1;

    /* Zwei fertige Frames verhindern ein kurzes Aufblitzen halbfertiger Layer. */
    if (stableReadyFrames < 2) {
      requestAnimationFrame(scheduleCheck);
      return;
    }

    delete document.documentElement.dataset.smoofVariantTransition;

    if (cover) {
      cover.dataset.visible = 'false';
      cover.setAttribute('aria-hidden', 'true');
    }

    expectedState = null;
    stableReadyFrames = 0;
  }

  function scheduleCheck() {
    if (checkPending) return;
    checkPending = true;
    requestAnimationFrame(endTransitionIfReady);
  }

  document.addEventListener('pointerdown', captureExpectedState, true);
  document.addEventListener('keydown', captureExpectedState, true);
  window.addEventListener('smoof:shopify-variant-change', scheduleCheck);

  new MutationObserver(scheduleCheck).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
      'checked',
      'data-smoof-variant-transition',
      'data-visible',
      'data-smoof-product-scene-base',
      'data-smoof-wood'
    ]
  });
})();
